import { ApplicationCompanyInfo } from "../../features/api-interfaces";

// 申請内容照会のラベル
export const LABELS = {
  APPLICATION_INQUIRY: "申請内容照会",
  APPLICATION_NO: "申請番号",
  APPLICATION_STATUS: "申請状況",
  APPLICATION_DETAIL_STATUS: "申請状況詳細",
  APPLICATION_MANAGER: "申請者",
  FILING_DATE: "申請日",
  ANSWER_START_TIME: "回答日時",
  APPLICATION_TYPE: "申請種別",
  INCOMPLETION_REASON: "差戻理由",
  MERCHANT_ANSWERED: "加盟店回答",
  INDIVIDUAL_HANDLING_STATUTE_OF_LIMITATIONS: "個別取扱事項",
  APPLICATION_FORM_TYPE: "申請書種別",
  CONTRACT: "契約書",
  PROPOSAL: "提案書",
  NUMBER_OF_STORES_TENANTS: "店舗数",
  APPLICANT_USER_TYPE: "申請者種別",
  APPLICANT_EMAIL: "申請者メールアドレス",
  RATE_NOTICE: "料率通知書",
  EMPTY_SPACE: "　　　　　　　　　　",
  COMPANY: "事業者名　　　　　　",
  BUSINESS_FORM: "事業形態　　　　　　",
  CORPORATE_NUMBER: "法人番号　　　　　　",
  REPRESENTATIVE: "代表者名　　　　　　",
  MERCHANT_CATEGORY: "加盟店カテゴリ　　　",
  MERCHANT_NAME: "申請加盟店名　　　　",
  POST_CODE: "郵便番号　　　　　　",
  ADDRESS: "住所　　　　　　　　",
  TEL: "ＴＥＬ　　　　　　　",
  AMOUNT_OF_SALES: "売上高　　　　　　　",
  SERVICE: "サービス　　　　　　",
  QR_PRESENTATION: "ＱＲ提示区分　　　　",
  CONTRACT_ROUTE: "契約ルート　　　　　",
  COMMISSION_RATE: "手数料率　　　　　　",
  CPID: "サイトID　　　　　　",
  PARTICULAR_RATE: "特別料率　　　　　　",
  TYPE_OF_CONTRACT: "契約形態　　　　　　",
  STORE_NAME: "店舗名",
  REJECTION_REASON: "差戻理由　　　　　　",
  SALES_STAFF: "営業担当",
  RETURN: "戻る",
  CONFIRMATION_OF_APPLICATION_INFORMATION: "確認業務",
  CONFIRMATION_OF_INDIVIDUAL_ATTENTION: "申請情報確認/",
  ADDITIONAL_REGISTRATION: "　追加登録　",
  APPLY_FOR_A_JOB: "　申請差戻　",
  ADMIT_BUSINESS: "　承認業務　",
  CORPORATE_INFORMATION: "事業者情報",
  STORE_INFORMATION: "店舗情報",
  YES: "有",
  NONE: "無",
  DONE: "済",
  CURRENT_INFO: "現情報",
  APPLICATION_INFO: "申請情報",
  DIFF_ITEM_CONTENT: "差分項目確認",
} as const;

// 申請内容照会の一番上の項目調整
export const LAYOUT_ADJUST_SPACE = {
  SPACE_4_SIZE: "　　　　",
  SPACE_5_SIZE: "　　　　　",
  SPACE_6_SIZE: "　　　　　　",
  SPACE_7_SIZE: "　　　　　　　",
} as const;

// 申請状況 申込受付
export const APPLICATION_STATUS_ACCEPTING = "01";

// 差分項目を確認する項目一覧
export type ApplicationContentKey = Exclude<
  keyof ApplicationCompanyInfo,
  | "contractStyle"
  | "contractRoute"
  | "contractServiceCode"
  | "soleProprietorshipFlag"
  | "particularRateFlag"
  | "qr"
>;
export const APPLICATION_CONTENT: Record<ApplicationContentKey, string> = {
  cpid: "サイトＩＤ",
  corporateNumber: "法人番号",
  companyName: "事業者名",
  companyNameItemScreenDisplay: "事業者名（明細表示用）",
  companyNameKana: "事業者名カナ",
  companyNameAlphabetical: "事業者名英字",
  postalCode: "郵便番号",
  address: "住所",
  addressKana: "住所カナ",
  phoneNumber: "電話番号",
  repName: "代表者名",
  repNameKana: "代表者名カナ",
  repNameAlphabetical: "代表者名英字",
  repBirthdate: "代表者生年月日",
  repCountry: "代表者居住国",
  companyUrl: "ホームページＵＲＬ",
  merchantName: "加盟店名",
  merchantNameKana: "加盟店名カナ",
  merchantNameAlphabetical: "加盟店名英字",
  merchantType: "加盟店種別",
  industryName: "業態",
  industrySupplement: "業態補足",
  licenseType: "許可証名称",
  licenseApplicationNumber: "許可証番号",
  sales: "加盟店売上高",
  commercialFacilityPostalCode: "商業施設郵便番号",
  commercialFacilityAddress: "商業施設住所",
  commercialFacilityAddressKana: "商業施設住所カナ",
  commercialFacilityPhoneNumber: "商業施設電話番号",
  settlementFeeRate: "手数料率",
  effectiveDate: "適用日",
  endDate: "解約希望日",
};
// 差分項目を確認する日付項目一覧
export const APP_CONTENT_DATE_PARAM = [
  "repBirthdate",
  "effectiveDate",
  "endDate",
];
